import React from 'react';
import ServiceDetailTemplate from '../components/service/ServiceDetailTemplate';

function InteligenciaMercado() {
    const data = {
        title: "Inteligência de Mercado",
        // Seguindo a sequência: /assets/images/novos/1/5.png
        mainImage: "/assets/images/novos/1/5.png",
        description1: "Apoio estratégico fundamental para tomadas de decisão financeiras e empresariais de alto impacto.",
        description2: "Transformamos dados e cenários em clareza estratégica, permitindo que sua empresa cresça com base em fundamentos sólidos.",
        cards: [
            // Mantendo o padrão de ícones absolutos: /assets/images/servicos/3/1.png
            { 
                icon: "/assets/images/servicos/3/1.png", 
                title: "Estudos de Viabilidade", 
                disc: "Análise técnica de novos projetos e expansões de negócios." 
            },
            { 
                icon: "/assets/images/servicos/3/1.png", 
                title: "Planejamento Estratégico", 
                disc: "Desenho de rotas para crescimento e estabilidade financeira." 
            },
            { 
                icon: "/assets/images/servicos/3/1.png", 
                title: "Inteligência Setorial", 
                disc: "Análise profunda de tendências e concorrência no seu nicho." 
            },
            { 
                icon: "/assets/images/servicos/3/1.png", 
                title: "Decisões de Investimento", 
                disc: "Suporte consultivo para alocação eficiente de capital." 
            }
        ],
        processSteps: [
            { title: "Coleta", disc: "Levantamento de dados internos e externos do mercado." },
            { title: "Análise", disc: "Processamento de informações com foco em riscos e oportunidades." },
            { title: "Estratégia", disc: "Entrega de relatórios acionáveis para o board executivo." }
        ],
        benefitTitle: "Serviços Consultivos",
        benefitDisc: "Damos suporte a empresas que buscam:",
        benefits: [
            "Estruturação financeira avançada",
            "Mapeamento de riscos de mercado",
            "Identificação de novos nichos de lucro",
            "Otimização de processos decisórios"
        ]
    };

    return <ServiceDetailTemplate {...data} />;
}

export default InteligenciaMercado;